import { render, staticRenderFns } from "./DrawerButton.vue?vue&type=template&id=2473f834&"
import script from "./DrawerButton.vue?vue&type=script&lang=js&"
export * from "./DrawerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports